import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Redirect, RouteComponentProps, withRouter } from 'react-router';
import { SpeechesData } from '../stores';
import { Modal } from './Modal';
import { YoutubeVideo } from './YoutubeVideo';

type RouteParams = RouteComponentProps<{ year: string, link: string, video: string }>;

interface Injected {
    speeches: SpeechesData
}

@(withRouter as ClassDecorator)
@inject('speeches')
@observer
export class VideoModalView extends React.Component<{ url: string } & Partial<Injected> & Partial<RouteParams>> {
    private onClose = () => {
        const { history } = this.props;
        if (history.location.pathname === this.returnUrl) return;
        history.push(this.returnUrl);
    };

    @computed get isMatching(): boolean {
        const { speeches, match } = this.props;
        const { year, link, video } = match.params;
        const yearElement = speeches && speeches.byYear[year];
        const matchingElement = yearElement && yearElement.filter(d => d.link === link).pop();
        return matchingElement && matchingElement.youtubeIds.includes(video);
    }

    @computed
    private get returnUrl(): string {
        const { url, match } = this.props;
        return url + '/' + match.params.link;
    }

    render() {
        const { speeches, match } = this.props;
        const { video } = match.params;

        if (speeches.isLoading) {
            return null;
        }

        if (!this.isMatching) {
            return <Redirect to={this.returnUrl} />;
        }

        return (
            <Modal onClose={this.onClose}>
                <YoutubeVideo id={video} />
            </Modal>
        );
    }

}

